import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ViewSubcategoryDetails } from '../../../../components/admin-dashboard-component/subcategories/view-subcategory-details/view-subcategory-details';

@Component({
  selector: 'app-admin-view-subcategory',
  imports: [ViewSubcategoryDetails],
  templateUrl: './admin-view-subcategory.html',
  styleUrl: './admin-view-subcategory.scss',
})
export class AdminViewSubcategory {
  private route = inject(ActivatedRoute);
  subcategoryId = this.route.snapshot.paramMap.get('id');
}
